<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-row mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex mu-flex-row mu-w-100">
                    <h1 class="mu-mb-00">Custom View Details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p>
                                {{ (isEditPage && !isCopyPage) ? helpTextEdit.title : helpTextCreate.title }}
                                <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Process Engine</li>
                    <li>
                        <router-link :to="CONTEXT_PATH + '/processengine/tasks'">Tasks</router-link>
                    </li>
                    <li aria-current="page">{{(isEditPage && !isCopyPage) ? customViewName : 'Create New'}}</li>
                </ol>
            </nav>
        </div>
       
        <form novalidate id="customViewForm" @submit.prevent="save()" >
            <div class="mcc-row" v-show="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-card mu-p-06">
                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="isEditPage && !isCopyPage && !isOwner" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p  v-if="isEditable">This custom view is shared with editable rights by {{sharedByUserFN}} {{sharedByUserLN}}.</p>
                            <p v-if="!isEditable">This custom view is shared with read-only rights by {{sharedByUserFN}} {{sharedByUserLN}}, please contact owner for editable rights.</p>
                        </mcc-alert>
                    </div>
                </div>
                <div class="mcc-row" v-show="fetchCall">
                    <div class="mcc-col mcc-col-md-12">
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mfc-slim-select-wrapper  mu-mb-03 mfc-form-input-container mfc-form-input-wrapper--width">
                                    <label for="processDefinitionId" class="mfc-label--required mu-mb-00">Process</label>
                                    <select class="mfc-slim-select" @change="handleProcessChange($event)" :disabled="isEditPage" ref="processDefinitionId" name="processDefinitionId" id="processDefinitionId" required>
                                    </select>
                                </div>
                                <div class="mfc-slim-select-wrapper mu-mb-03 mfc-form-input-container  mfc-form-input-wrapper--width">
                                    <label for="databaseVendor" class="mfc-label--required mu-mb-00">Process Variables</label>
                                    <select class="mfc-slim-select" multiple required  @change="changeProcessVariable($event)" ref="variables" name="variables" id="databaseVendor">
                                       
                                    </select>
                                    <div class="mfc-help-text">Maximum 10 variables can be selected.</div>
                                </div>
                                <div class="mfc-input-wrapper mfc-form-input-container  mfc-form-input-wrapper--width">
                                    <label for="name" class="mfc-label--required mu-mb-00">Name</label>
                                    <input type="text" name="name" maxlength="50" id="name" required="" :disabled="isEditPage && !isCopyPage && !isEditable" @change="updateName($event)" ref="name" :pattern="nameRegex">

                                </div>
                                <div class="mu-d-flex mu-justify-content-end mu-mt-05 mu-gap-05" >
                                    <div role="group" class="mcc-button-group ">
                                        <router-link v-if="!isEditPage" :to="CONTEXT_PATH + '/processengine/tasks'">
                                            <button class="mcc-button mcc-button--outline" title="Cancel" id="customViewTaskCancelBtn" type="button">
                                                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                            </button>
                                        </router-link>
                                        <router-link v-if="isCopyPage" :to="CONTEXT_PATH + '/processengine/tasks/customview/' + customViewId">
                                            <button class="mcc-button mcc-button--outline" title="Cancel" id="customViewTaskCancelBtn" type="button">
                                                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                            </button>
                                        </router-link>

                                        <div role="group" aria-label="Copy" class="mcc-button-group mcc-menu__split-button" v-if="isEditPage && !isCopyPage && isEditable">

                                            <button class="mcc-button mcc-button--outline" type="button" @click="handleCopyClick()" id="copyBtn" title="Copy">
                                                <mcc-icon name="copy" aria-hidden="true"></mcc-icon>
                                                <span class="mcc-button__label">Copy</span>
                                            </button>
                                            <details class="mcc-dropdown">
                                                <summary class="mcc-button mcc-button--outline mu-border-start" aria-haspopup="true">
                                                    <span class="[ mcc-button__label ] [ mu-visually-hidden ]">Dropdown</span>
                                                    <mcc-icon class="[ mcc-button__dropdown-caret ] [ mu-ml-00 ]" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                                </summary>
                                                <ul class="mcc-dropdown__menu">
                                                    <li>
                                                        <button title="Delete" id="deleteCustomViewTaskBtn" type="button" @click="$refs.deleteCustomViewDialog.show()">
                                                            <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                                        </button>
                                                        <button title="Share" id="shareBtn" type="button" @click="showShareDialog()">
                                                            <mcc-icon name="share" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Share</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </details>
                                        </div>
                                    </div>
                                    <button class="mcc-button mcc-button--outline" v-if="isEditPage && !isCopyPage && !isEditable" id="copyBtn" title="Copy" @click="handleCopyClick()" type="button">
                                        <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                                    </button>
                                    <button class="mcc-button mcc-button--soft-primary" v-if="isEditable || !isEditPage || isCopyPage" title="Preview" id="previewBtnTask" @click="generatePreviewBtnClick()" type="button">
                                        <mcc-icon name="preview_pane" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Preview</span>
                                    </button>
                                    <button class="mcc-button mcc-button--success" v-if="isEditable || !isEditPage || isCopyPage" id="customViewTaskSubmitBtn" title="Save" type="submit">
                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="mu-mt-05">
                        <div class="mcc-row" v-show="!previewCall">
                            <div class="mcc-col colSpinner">
                                <div class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-row" v-show="previewCall">
                            <div class="mcc-col mcc-col-md-12">
                                <div style="position:relative">
                                    <div class="mcc-card" v-show="showPreviewGrid">
                                        <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                            <div>
                                                <h2 class="mcc-card__title">Process Variables</h2>
                                            </div>
                                        </div>
                                        <div class="mcc-card__body">
                                            <div class="mcc-row">
                                                <div class="mcc-col">
                                                    <div class="mu-d-flex mu-justify-content-end mu-pb-06" v-if="isEditable">
                                                        <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()" type="button">
                                                            <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                                            <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '(2)' }}</span>
                                                        </button>
                                                    </div>
                                                    <mcc-data-table ref="customViewtableTask" id="customViewtableTask"></mcc-data-table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        </div>
   
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--danger" v-if="isDataAvailable" color="danger" id="deleteCustomViewDialog" ref="deleteCustomViewDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete Custom View</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteCustomViewDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to delete this custom view?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteCustomViewDialog.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <Drawer ref="customFilter" @reset-filter="resetFilterBtnClick" @apply-filter="submitDialog" title="Task Filters">
      
            <div class="mcc-card mu-border-0">
                <div class="mcc-row">
                    <div class="mcc-col">
                        <form id="formIdd">
                        <div>
                            <div class="mfc-input-wrapper mfc-form-input-container">
                                <label for="name">Task name</label>
                                <input type="text" name="task-name" maxlength="100" id="name" :pattern="nameRegex" :value="taskNameRef" @change="taskNameRef = $event.target.value">
                            </div>
                            <div class="mt-2">
                                <div class="mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                    <fieldset class="mfc-fieldset">
                                        <legend class="mfc-label">
                                            Status
                                        </legend>
                                        <div class="mcc-segmented-buttons__list" :value="statusRef" ref="radioRef" name="status-radioGroup" id="status-radioGroup">
                                            <input type="checkbox" value="open" id="open-selectID" name="open" @click="statusRef = $event.target.value" :checked="statusRef == 'open'">
                                            <label class="mcc-segmented-buttons__button" for="open-selectID">
                                                <span class="mcc-segmented-buttons__label">Open</span>
                                            </label>
                                            <input type="checkbox" value="completed" id="completed" name="completed" @click="statusRef = $event.target.value" :checked="statusRef == 'completed'">
                                            <label class="mcc-segmented-buttons__button" for="completed">
                                                <span class="mcc-segmented-buttons__label">Completed</span>
                                            </label>
                                            <input type="checkbox" name="all" value="all" id="all" @click="statusRef = $event.target.value" :checked="statusRef == 'all'">
                                            <label class="mcc-segmented-buttons__button" for="all">
                                                <span class="mcc-segmented-buttons__label">All</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="mt-2">
                                <div class=" mcc-segmented-buttons mcc-segmented-buttons--sm ">
                                    <fieldset class="mfc-fieldset">
                                        <legend class="mfc-label">
                                            Priority
                                        </legend>
                                        <div class="mcc-segmented-buttons__list" block ref="priorityRef" name="priority-radioGroup" id="priority-radioGroup">
                                            <input type="checkbox" name="Low" value="0" id="Low" @click="priorityRef = $event.target.value" :checked="priorityRef == '0'">
                                            <label class="mcc-segmented-buttons__button" for="Low">
                                                <span class="mcc-segmented-buttons__label">Low</span>
                                            </label>
                                            <input type="checkbox" name="Normal" value="50" id="Normal" @click="priorityRef = $event.target.value" :checked="priorityRef == '50'">
                                            <label class="mcc-segmented-buttons__button" for="Normal">
                                                <span class="mcc-segmented-buttons__label">Normal</span>
                                            </label>
                                            <input type="checkbox" name="High" value="100" id="High" @click="priorityRef = $event.target.value" :checked="priorityRef == '100'">
                                            <label class="mcc-segmented-buttons__button" for="High">
                                                <span class="mcc-segmented-buttons__label">High</span>
                                            </label>
                                            <input type="checkbox" name="All" value=" " id="All" @click="priorityRef = $event.target.value" :checked="priorityRef == ' '">
                                            <label class="mcc-segmented-buttons__button" for="All">
                                                <span class="mcc-segmented-buttons__label">All</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                            <div class="mfc-slim-select-wrapper mu-mb-03">
                                <label for="Assignee-selectId">Assignee</label>
                                <select class="mfc-slim-select" :data-value="selectedAssigneeRef" @change="selectedAssigneeRef = $event.target.value" ref="assigneeRef" name="Assignee-select" id="Assignee-selectId">
                                    <option data-placeholder="true" value=""></option>
                                    <option :selected="selectedAssigneeRef === 'unassigned'" value="unassigned">NO ASSIGNEE</option>
                                    <option :selected="selectedAssigneeRef === 'claimed'" value="claimed">CLAIMED</option>
                                    <option v-for="(app,key) in userList" :selected="selectedAssigneeRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>
                                </select>
                            </div>
                            <div class="mfc-slim-select-wrapper mu-mb-03">
                                <label for="owner-selectId">Owner</label>
                                <select class="mfc-slim-select" :data-value="selectedOwnerRef" @change="selectedOwnerRef = $event.target.value" ref="ownerRef" name="owner-select" id="owner-selectId">
                                    <option data-placeholder="true" value=""></option>
                                    <option v-for="(app,key) in userList" :selected="selectedOwnerRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>
                                </select>
                            </div>
                            <div class="mfc-slim-select-wrapper mu-mb-03">
                                <label for="Involving-selectId">Involving</label>
                                <select class="mfc-slim-select" :data-value="selectedInvolvingRef" @change="selectedInvolvingRef = $event.target.value" ref="involvingRef" name="Involving-select" id="Involving-selectId">
                                    <option data-placeholder="true" value=""></option>
                                    <option v-for="(app,key) in userList" :selected="selectedInvolvingRef === app.username" :key="key" :value="app.username">{{app.firstName}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div class="flatpickr flatpickrGap mfc-input-wrapper ">
                                    <label for="startDateId" class=" mb-0">Created between</label>
                                    <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text  flatpickrInstance" id="dateFromId">
                                        <input name="startDate" id="startDateId" data-input ref="startDate" placeholder="Select Date.." icon="calendar" @change="handleStartRangeChange($event)" @ready="handleStartRangeReady()">
                                        <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                            <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                        </button>
                                        <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                            <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                            <span>Please select proper dates.</span>
                                        </div>
                                    </div>
                                </div>
                           
                                <div class="flatpickr flatpickrGap mfc-input-wrapper">
                                    <label for="endDateId" class=" mb-0">Completed between</label>
                                    <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text  flatpickrInstances" id="dateToId">
                                        <input name="endDate" id="endDateId" ref="endDate" data-input icon="calendar" placeholder="Select Date.." @change="handleEndRangeChange($event)" @ready="handleEndRangeReady()">
                                        <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date">
                                            <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                        </button>
                                        <div id="mds_text_feedback" class="mfc-invalid-feedback">
                                            <mcc-icon name="error" width="24" height="24"></mcc-icon>
                                            <span>Please select proper dates.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
       
    </Drawer>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--primary"  id="shareDialog" ref="shareCustomDialog">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Share Custom View</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeShareDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <!-- <div v-if="updateShareDialog"> -->
                                <div>
                                    <div class="mcc-tabs mcc-tabs--compact mcc-tabs--bar" @change="handleTabChange($event)">
                                        <input type="radio" id="as-default-tab1" name="as-default-tab-control" checked="">
                                        <input type="radio" id="as-default-tab2" name="as-default-tab-control">
                                        <ul role="tablist" class="mu-mb-05">
                                            <li role="tab">
                                                <label for="as-default-tab1" tabindex="0">
                                                    <span>Read only</span>
                                                </label>
                                            </li>
                                            <li role="tab">
                                                <label for="as-default-tab2" tabindex="0">
                                                    <span>Editable</span>
                                                </label>
                                            </li>
                                        </ul>
                                        <div role="tabpanel">
                                            <div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mu-mb-03">
                                                    <label for="readOnlyUsers" class=" mu-mb-00">Users</label>
                                                    <div id="readOnlyUsersSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeROUserSelect" name="readOnlyUsers" id="readOnlyUsers" ref="readOnlyUsers" multiple>
                                                        <option v-for="(user,key) in allReadOnlyUsers" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                                    </select>
                                                </div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mu-mb-03">
                                                    <label for="readOnlyGroups" class=" mu-mb-00">Groups</label>
                                                    <div id="readOnlyGroupsSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeROGroupSelect" name="readOnlyGroups" id="readOnlyGroups" ref="readOnlyGroups" multiple>
   <option v-for="(group,key) in allReadOnlyGroups" :key="key" :value="group.id">{{group.name}}</option>   
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel">
                                            <div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mu-mb-03">
                                                    <label for="editableUsers" class=" mu-mb-00">Users</label>
                                                    <div id="editableUsersSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeEditableUserSelect" name="editableUsers" id="editableUsers" ref="editableUsers" multiple>
   <option v-for="(user,key) in allEditableUsers" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>                                                   </select> 
                                                </div>
                                                <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mu-mb-03">
                                                    <label for="editableGroups" class=" mu-mb-00">Groups</label>
                                                    <div id="editableGroupsSelectedIdDiv"></div>
                                                    <select class="mfc-slim-select" @change="handleChangeEditableGroupSelect" name="editableGroups" id="editableGroups" ref="editableGroups" block label="Groups" multiple>
  <option v-for="(group,key) in allEditableGroups" :key="key" :value="group.id">{{group.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeShareDialog()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="shareCustomView()">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import CustomViewAPI from "../../../services/CustomViewAPI";
import MyProcessListAPI from "../../../services/MyProcessListAPI";
import TaskAPI from "../../../services/MyTaskListAPI";
import {
    EventBus
} from "../../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid';
import constantMessages from "../../../messages";
import AdminHttpAPI from "../../../services/AdminHttpAPI";
import Utils from "@/script_utils";
import HierarchyAPI from "../../../services/HierarchyAPI";
import Drawer from "../../common/Drawer.vue";

export default {
    name: "CustomViewTask",
    components: {
        Drawer
    },
    data() {
        return {
            customView: {
                processVariables: {
                    aliasName: '',
                    type: 'task',
                    variablesjson: '',
                    processDefinitionId: '',
                },
                customViewFilterDTO: {}
            },
            emptyField: {
                "text": "",
                "value": ""
            },
            helpTextCreate: constantMessages.BREADCRUMB_HELP["processengine.tasks.customView.create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["processengine.tasks.customView.edit"],
            nameRegex: constantMessages.PATTERNS["customName"],
            showHelpText: false,
            currentPageSize: 10,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            processDefinitions: [],
            customViewId: this.$route.params.customViewId,
            isEditPage: true,
            fetchCall: false,
            previewCall: true,
            isDataAvailable: false,
            customViewName: '',
            showPreviewGrid: false,
            statusRef: "open",
            statusType: "open",
            taskNameRef: "",
            taskName: "",
            priorityRef: " ",
            priority: " ",
            selectedInvolvingRef: "",
            selectedInvolving: "",
            selectedAssigneeRef: "",
            selectedAssignee: "",
            selectedOwnerRef: "",
            selectedOwner: "",
            startedAfter: "",
            startedBefore: "",
            finishedAfter: "",
            finishedBefore: "",
            startDateRangeRef: [],
            endDateRangeRef: [],
            userList: {},
            allReadOnlyUsers: [],
            allEditableUsers: [],
            showSpinner: false,
            filterVariables: [],
            isCopyPage: false,
            showReadonlyTab: false,
            showEditableTab: false,
            updateShareDialog: false,
            selectedROUsers: [],
            selectedEditableUsers: [],
            isOwner: false,
            isEditable: true,
            usersWithRORight: [],
            usersWithEditableRight: [],
            currentUserName: "",
            sharedByUserFN: "",
            sharedByUserLN: "",
            groupsWithEditableRights: [],
            groupsWithReadOnlyRights: [],
            activeGroups: [],
            selectedROGroups: [],
            selectedEditableGroups: [],
            allEditableGroups: [],
            allReadOnlyGroups: [],
            tableData: [],
            selectProcess: {},
            variableOptions: {},
            selectedVariables: {},
            processDefinitionInstance: null,
            databaseVendorInstance: null,
            assigneeSelectId: null,
            ownerSelectId: null,
            involvingSelectId: null,
            variableData: "",
            filterCount: 0,
            readOnlyUsersSlimInstance: null,
            readOnlyGroupsSlimInstance: null,
            editableUsersSlimInstance: null,
            editableGroupsSlimInstance: null,
            updatingSlimSelect: true
        }
    },
    watch: {
        isEditPage: 'checkAndToggleVariablesCVProcessInstance',     
        isCopyPage: 'checkAndToggleVariablesCVProcessInstance',     
        isEditable: 'checkAndToggleVariablesCVProcessInstance',
        allEditableGroups(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
    allReadOnlyGroups(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
    allReadOnlyUsers(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
    allEditableUsers(newValue, oldValue) {
      if (!this.updatingSlimSelect && JSON.stringify(newValue) !== JSON.stringify(oldValue))  {
        this.updateSlimSelects();
      }
    },
  },
    
    created() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.fetchCall = false;
        self.isEditPage = self.customViewId != null && self.customViewId != 'new';
        self.isCopyPage = self.$route.path.includes("copy");

        if (this.customViewId != null && this.customViewId != 'new') {

            HierarchyAPI.getActiveGroups()
                .then(result => {
                    self.activeGroups = result.data;
                    self.allEditableGroups = result.data;
                    self.allReadOnlyGroups = result.data;
                });

            let editData = {};
            CustomViewAPI.getCustomViewData(self.customViewId).then(response => {
                    if (response != null) {
                        self.isDataAvailable = true;
                        editData = response;
                        self.isOwner = response.data.isOwner;
                        self.isEditable = response.data.isEditable;
                        self.usersWithRORight = response.data.usersWithRORight;
                        self.usersWithEditableRight = response.data.usersWithEditableRight;
                        self.groupsWithEditableRights = response.data.editableGroups;
                        self.groupsWithReadOnlyRights = response.data.readOnlyGroups;
                        self.currentUserName = response.data.currentUserName;
                        self.sharedByUserFN = response.data.sharedByFN;
                        self.sharedByUserLN = response.data.sharedByLN;
                    }
                })
                .finally(() => {
                    self.variableData = editData.data.customView.customViewFilterDTO.variables.join(",")
                    self.fetchCall = true;
                    self.initializeCustmViewData(editData.data);
                    self.initializeProcessDefinition(editData.data);
                    self.initializeVariables(editData);
                });
        } else {
            let procDefArr = [];
            CustomViewAPI.getLatestProcessDefinitions().then(response => {
                    self.fetchCall = true;
                    if (response != null) {
                        procDefArr.push({
                            value: '',
                            text: ''
                        });
                        $.each(response, function (i, definition) {
                            let obj = {
                                value: definition.id,
                                text: definition.name
                            };
                            procDefArr.push(obj);
                        });
                    }
                })
                .finally(() => {
                    self.setProcessDefinitionData(procDefArr);
                });
        }

        MyProcessListAPI.getUsers().then(result => {
            self.userList = result;
            self.allReadOnlyUsers = result;
            self.allEditableUsers = result;
        });
    },
    updated() {
        this.flatPickr()
    },
    mounted() {
        this.processDefinitionInstance = new SlimSelect({
            select: '#processDefinitionId',
        });

        this.databaseVendorInstance = new SlimSelect({
            select: '#databaseVendor',
            settings: {
            closeOnSelect: false,
            maxSelected: 10,
            allowDeselect: true
            },
        });
        this.assigneeSelectId = new SlimSelect({
            select: '#Assignee-selectId',

        });
        this.ownerSelectId = new SlimSelect({
            select: '#owner-selectId',

        });
        this.involvingSelectId = new SlimSelect({
            select: '#Involving-selectId',

        });
        this.readOnlyUsersSlim()
        this.readOnlyGroupsSlim()
        this.editableUsersSlim()
        this.editableGroupsSlim()
        this.flatPickr()
    },

    methods: {
        checkAndToggleVariablesCVProcessInstance() {         
            if (this.isEditPage && !this.isCopyPage && !this.isEditable) {             
                this.databaseVendorInstance.disable();         
            } else { 
                this.databaseVendorInstance.enable(); 
            } 
        },
        updateSlimSelects()
        {
            let self= this;
            self.updatingSlimSelect = true;
                 self.editableGroupsSlimInstance.setData(self.allEditableGroups.map(user => ({
          text: user.name,
          value: user.id,


        })));
         self.readOnlyGroupsSlimInstance.setData(self.allReadOnlyGroups.map(group => ({
         text: group.name,
          value: group.id,

       })));
     self.editableUsersSlimInstance.setData(self.allEditableUsers.map(user => {
        const fullName = user.surname ? `${user.firstName} ${user.surname}` : user.firstName;
    return {
      text: fullName,
      value: user.username
    };
        }));

     self.readOnlyUsersSlimInstance.setData(self.allReadOnlyUsers.map(user => {
        const fullName = user.surname ? `${user.firstName} ${user.surname}` : user.firstName;
    return {
      text: fullName,
      value: user.username
    };
        }));
       self.editableGroupsSlimInstance.setSelected(self.selectedEditableGroups);
      self.readOnlyGroupsSlimInstance.setSelected(self.selectedROGroups);
      self.editableUsersSlimInstance.setSelected(self.selectedEditableUsers)
      self.readOnlyUsersSlimInstance.setSelected(self.selectedROUsers)

            self.updatingSlimSelect = false;
        },
        readOnlyUsersSlim()
        {
          this.readOnlyUsersSlimInstance =  new SlimSelect({
            select: '#readOnlyUsers',
            settings: {
            closeOnSelect: false,
            contentPosition: 'absolute',
            openPosition: 'down',
                contentLocation: document.getElementById('readOnlyUsersSelectedIdDiv')
            }

        });
        },
        readOnlyGroupsSlim()
        {
          this.readOnlyGroupsSlimInstance =  new SlimSelect({
                  select: '#readOnlyGroups',
                  settings: {
                  closeOnSelect: false,
                  contentPosition: 'absolute',
                  openPosition: 'down',
                contentLocation: document.getElementById('readOnlyGroupsSelectedIdDiv')
              }
            });
        },
        editableUsersSlim()
        {
           this.editableUsersSlimInstance = new SlimSelect({
            select: '#editableUsers',
            settings: {
                closeOnSelect: false,
                contentPosition: 'absolute',
                openPosition: 'down',
                contentLocation: document.getElementById('editableUsersSelectedIdDiv')
            }
        });
        },
        editableGroupsSlim()
        {
           this.editableGroupsSlimInstance = new SlimSelect({
            select: '#editableGroups',
            settings: {
                closeOnSelect: false,
                contentPosition: 'absolute',
                openPosition: 'down',
                contentLocation: document.getElementById('editableGroupsSelectedIdDiv')
            }
             });
        },
        changeProcessVariable(event) {
            if (this.databaseVendorInstance.getSelected()) {
                this.customView.customViewFilterDTO.variables = this.databaseVendorInstance.getSelected();
            }
        },
        async setProcessDefinitionData(procDefArr) {
            await this.$nextTick();
            this.processDefinitionInstance.setData(procDefArr);
        },
        handleCopyClick() {
            let self = this;
            this.$router
                .push(
                    this.CONTEXT_PATH + '/processengine/tasks/customview/' + self.customViewId + '/copy'
                )
        },
        showShareDialog() {
            let self = this;
            self.updatingSlimSelect = false;
            self.$refs.shareCustomDialog.show();
            $("#as-default-tab1").prop("checked", true); 
            self.selectedROUsers = self.usersWithRORight;
            self.selectedEditableUsers = self.usersWithEditableRight;
            self.selectedEditableGroups = self.groupsWithEditableRights;
            self.selectedROGroups = self.groupsWithReadOnlyRights;
            let editUsers = self.userList;
           let readonlyUsers = self.userList;
            self.allEditableUsers = editUsers.filter(user => (!self.selectedROUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));
            self.allReadOnlyUsers = readonlyUsers.filter(user => (!self.selectedEditableUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));
            let editGroup = self.activeGroups;
            let readonlyGroup = self.activeGroups;
            self.allEditableGroups = editGroup.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedROGroups.includes(group.id)

    } else {
        return false;
    }
});       
self.allReadOnlyGroups = readonlyGroup.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedEditableGroups.includes(group.id)
    } else {
        return false;
    }
});            this.updateShareDialog = true;
            this.showReadonlyTab = true;
           
        },
        closeShareDialog() {
            this.updateShareDialog = false;
            this.showReadonlyTab = false;
            this.showEditableTab = false;
            this.$refs.shareCustomDialog.close();
        },
        handleTabChange(e) {
            let self = this;
            if (e.target.localName == "mcc-tabs") {
                if (e.detail.id == "readonlyTab") {
                    this.showEditableTab = false;
                    this.showReadonlyTab = true;
                    setTimeout(() => {
                        self.readOnlyUsersSlimInstance.setSelected(self.selectedROUsers)
                        self.readOnlyGroupsSlimInstance.setSelected(self.selectedROGroups)
                    }, 0);
                } else {
                    this.showReadonlyTab = false;
                    this.showEditableTab = true;
                    setTimeout(() => {
                        self.editableUsersSlimInstance.setSelected(self.selectedEditableUsers)
                        self.editableGroupsSlimInstance.setSelected(self.selectedEditableGroups)

                    }, 0);
                }
            }
        },
        handleChangeROGroupSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedROGroups = self.readOnlyGroupsSlimInstance.getSelected();
            self.selectedROGroups = self.selectedROGroups.map(value => {
    return Number(value);
});
            let activeROGroups = self.activeGroups;
            self.allEditableGroups = activeROGroups.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedROGroups.includes(group.id)

    } else {
        return false;
    }
});
        },
        handleChangeEditableGroupSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedEditableGroups = self.editableGroupsSlimInstance.getSelected()
self.selectedEditableGroups = self.selectedEditableGroups.map(value => {
    return Number(value);
});

            let activeEditGroup = self.activeGroups;
            self.allReadOnlyGroups = activeEditGroup.filter(group => {
    if (group.id !== undefined && group.id !== null) {
        return !self.selectedEditableGroups.includes(group.id)
    } else {
        return false;
    }
});      
        },
        handleChangeROUserSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedROUsers = self.readOnlyUsersSlimInstance.getSelected()
            let activeROUser = self.userList;
            self.allEditableUsers = activeROUser.filter(user => (!self.selectedROUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));  
       
    },
        handleChangeEditableUserSelect() {
            let self = this;
            if(self.updatingSlimSelect)
            return;
            self.selectedEditableUsers =self.editableUsersSlimInstance.getSelected()
            let activeGroupUser = self.userList;
            self.allReadOnlyUsers = activeGroupUser.filter(user => (!self.selectedEditableUsers.includes(user.username) && self.currentUserName != user.username && self.customView.processVariables.userName != user.username));
       
    },
        shareCustomView() {
            let self = this;
            self.$refs.shareCustomDialog.close()
            let customViewShareDTO = [];
            if (!self.isOwner && self.usersWithEditableRight.includes(self.currentUserName)) {
                self.selectedEditableUsers.push(self.currentUserName);
            }
            $.each(self.selectedROUsers, function (i, val) {
                let obj = {
                    "username": val,
                    "accessType": "READONLY"
                };
                customViewShareDTO.push(obj);
            });
            $.each(self.selectedEditableUsers, function (i, val) {
                let obj = {
                    "username": val,
                    "accessType": "EDITABLE"
                };
                customViewShareDTO.push(obj);
            });
            $.each(self.selectedROGroups, function (i, val) {
                let obj = {
                    "groupId": val,
                    "accessType": "READONLY"
                };
                customViewShareDTO.push(obj);
            });
            $.each(self.selectedEditableGroups, function (i, val) {
                let obj = {
                    "groupId": val,
                    "accessType": "EDITABLE"
                };
                customViewShareDTO.push(obj);
            });
            CustomViewAPI.shareCustomView(self.customViewId, customViewShareDTO).then(response => {
                EventBus.$emit("success-notification", {
                    msg: constantMessages.MESSAGES[response]
                });
                self.usersWithRORight = self.selectedROUsers;
                self.usersWithEditableRight = self.selectedEditableUsers;
                self.groupsWithReadOnlyRights = self.selectedROGroups;
                self.groupsWithEditableRights = self.selectedEditableGroups;
            });
        },
        flatPickr() {
            let self = this;
            self.flatPickerInstance = flatpickr('.flatpickrInstance', {
                dateFormat: 'd/M/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.startDateRangeRef[0], self.startDateRangeRef[1]],
            })

            self.flatPickerInstance = flatpickr('.flatpickrInstances', {
                dateFormat: 'd/M/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.endDateRangeRef[0], self.endDateRangeRef[1]],
            })

        },
        resetFilter() {
            this.filterCount = 0;
            this.statusRef = "open";
            this.taskNameRef = "";
            this.taskName = "";
            this.statusType = "open";
            this.priorityRef = " ";
            this.priority = " ";
            this.selectedInvolving = "";
            this.selectedInvolvingRef = "";
            this.selectedAssigneeRef = "";
            this.selectedOwnerRef = "";
            this.selectedOwner = "";
            this.selectedAssignee = "";
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            this.startDateRangeRef = "";
            this.endDateRangeRef = "";
            this.filterVariables = [];
            this.assigneeSelectId.setSelected([]);
            this.ownerSelectId.setSelected([]);
            this.involvingSelectId.setSelected([]);
            if(this.flatPickr('#startDateId')){
                this.flatPickr('#startDateId').destroy();
                this.flatpickr("#startDateId").clear();
            }
           if(this.flatPickr('#endDateId')){
                this.flatPickr('#endDateId').destroy();
                this.flatpickr("#endDateId").clear();
            }
        },
        resetFilterBtnClick() {
            this.resetFilter();
            this.initPreviewTable();
        },
        handleStartRangeChange(e) {
            this.startDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.startDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleStartRangeReady() {
            if (this.startDateRangeRef.length > 1) {
                this.$refs.startDate.value =
                    moment(this.startDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.startDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        handleEndRangeChange(e) {
            this.endDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.endDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleEndRangeReady() {
            if (this.endDateRangeRef.length > 1) {
                this.$refs.endDate.value =
                    moment(this.endDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.endDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        getFilterCount() {
            if (this.taskNameRef != "")
                this.filterCount += 1
            if (this.statusRef != "")
                this.filterCount += 1
            if (this.priorityRef != "")
                this.filterCount += 1
            if (this.selectedAssigneeRef != "")
                this.filterCount += 1
            if (this.selectedOwnerRef != "")
                this.filterCount += 1
            if (this.selectedInvolvingRef != "")
                this.filterCount += 1
            if (this.startDateRangeRef !== '')
                this.filterCount += 1
            if (this.endDateRangeRef !== '')
                this.filterCount += 1

        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            let self = this;
            self.filterVariables = [];
            self.updateDateRef();
            self.filterCount = 0;
            this.getFilterCount();
            let rowValues = []; //$("#variableFilters")[0].values;
            //rowValues.shift();
            $.each(rowValues, function (i, val) {
                let obj = {
                    "varName": val["Variable"],
                    "operator": val["Operator"],
                    "varValue": val["Value"],
                };
                self.filterVariables.push(obj);
            });
            this.statusType = this.statusRef;
            this.taskName = this.taskNameRef;
            this.priority = this.priorityRef;
            this.selectedInvolving = this.selectedInvolvingRef;
            this.selectedAssignee = this.selectedAssigneeRef;
            this.selectedOwner = this.selectedOwnerRef;
            this.initPreviewTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        updateDateRef() {
            let self = this;
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            if (self.startDateRangeRef.length > 0) {
                let startDateFrom = self.startDateRangeRef[0];
                let startDateTo = self.startDateRangeRef[1];
                let d = new Date(startDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.startedAfter = d.toISOString();
                if (!startDateTo) {
                    startDateTo = startDateFrom
                }
                d = new Date(startDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.startedBefore = d.toISOString();
            }
            if (!self.unclaimedTasks && self.endDateRangeRef.length > 0) {
                let endDateFrom = self.endDateRangeRef[0];
                let endDateTo = self.endDateRangeRef[1];
                let d = new Date(endDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.finishedAfter = d.toISOString();
                if (!endDateTo) {
                    endDateTo = endDateFrom
                }
                d = new Date(endDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.finishedBefore = d.toISOString();
            }
        },
        initializeCustmViewData(data) {
            let self = this;
            self.customView = data.customView;
            if (self.isCopyPage) {
                self.customViewName = data.customView.processVariables.aliasName + " - copy";
                if (self.customViewName.length > 50) {
                    self.customViewName = self.customViewName.substr(0, 50);
                }
                data.customView.processVariables.aliasName = self.customViewName;
            } else {
                self.customViewName = data.customView.processVariables.aliasName;
            }
            if (self.$refs.name != undefined) {
                self.$refs.name.value = self.customViewName;
            }

            let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.customview.details"] + " - " + self.customViewName;
            if (!self.isEditPage || self.isCopyPage) {
                pageTitle = constantMessages.PAGEHEADER_TITLE["menu.customview.details"] + " - Create new";
            }
            EventBus.$emit("update-pageTitle", pageTitle);
        },

        initializeProcessDefinition(data) {
            let self = this;
            let obj = [{
                value: data.customView.processVariables.processDefinitionId,
                text: data.customView.processDefinitionName
            }];

            if (self.customView.processVariables.processDefinitionId) {
                setTimeout(() => {
                    this.processDefinitionInstance.setData(obj)
                }, 100);
            }
        },
        initializeVariables(response) {
            let self = this;
            let varArr = [];
            $.each(response.data.allVariables, function (i, value) {
                let obj = {
                    text: value,
                    value: value
                };
                varArr.push(obj);
            });
            self.setFilterData(response.data.customView.customViewFilterDTO);
            self.databaseVendorInstance.setData(varArr);
            setTimeout(() => {
                self.databaseVendorInstance.setSelected(this.variableData.split(","));
                self.generatePreview();
            }, 1000);
        },
        setFilterData(customViewFilterDTO) {
            this.taskName = customViewFilterDTO.taskName;
            this.taskNameRef = customViewFilterDTO.taskName;
            this.statusType = customViewFilterDTO.status;
            this.statusRef = customViewFilterDTO.status;
            this.priority = customViewFilterDTO.priority;
            this.priorityRef = customViewFilterDTO.priority;
            this.selectedAssignee = customViewFilterDTO.assignee;
            this.selectedAssigneeRef = customViewFilterDTO.assignee;
            this.selectedOwner = customViewFilterDTO.owner;
            this.selectedOwnerRef = customViewFilterDTO.owner;
            this.selectedInvolving = customViewFilterDTO.involving;
            this.selectedInvolvingRef = customViewFilterDTO.involving;
            this.startDateRangeRef = customViewFilterDTO.startDateRange;if(document.querySelector('#owner-selectId')?.slim){
                this.ownerSelectId.destroy()
			}
			this.ownerSelectId = new SlimSelect({
			    select: '#owner-selectId'		
			})
            this.ownerSelectId.setSelected([customViewFilterDTO.owner]);
            if(document.querySelector('#Assignee-selectId')?.slim){
                this.assigneeSelectId.destroy()
            }
            this.assigneeSelectId = new SlimSelect({
                select: '#Assignee-selectId'		
            })
            this.assigneeSelectId.setSelected([customViewFilterDTO.assignee]);
            if(document.querySelector('#Involving-selectId')?.slim){
                this.involvingSelectId.destroy()
            }
            this.involvingSelectId = new SlimSelect({
                select: '#Involving-selectId'		
            })
            this.involvingSelectId.setSelected([customViewFilterDTO.involving]);

            document.querySelector("#dateFromId")._flatpickr.setDate(this.startDateRangeRef);
            this.endDateRangeRef = customViewFilterDTO.endDateRange;
            document.querySelector("#dateToId")._flatpickr.setDate(this.endDateRangeRef);
            this.updateDateRef();
            this.getFilterCount();
            this.filterVariables = customViewFilterDTO.variableFilterDTOs;
        },
        handleProcessChange(e) {
            let self = this;
            let processDefinitionId;
            this.databaseVendorInstance.setData([self.emptyField])

            processDefinitionId = $("#processDefinitionId")[0].value;
            self.customView.processVariables.processDefinitionId = processDefinitionId;
            if (processDefinitionId != "") {
                CustomViewAPI.getProcessvariablesForProcess(processDefinitionId).then(response => {
                    let varArr = [];
                    this.databaseVendorInstance.setData([self.emptyField])
                    if (response != null) {
                        $.each(response, function (i, value) {
                            let obj = {
                                text: value,
                                value: value
                            };
                            varArr.push(obj);
                        });
                        this.databaseVendorInstance.setData(varArr)
                    }
                });
            }
        },
        save() {
            let form = $('#customViewForm')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            $(this.$refs.name).addClass("required");
            $(this.$refs.name).attr("pattern", this.nameRegex);
            $(this.$refs.name).attr("maxlength", "50");
            self.customView.customViewFilterDTO.taskName = self.taskName;
            self.customView.customViewFilterDTO.status = self.statusType;
            self.customView.customViewFilterDTO.priority = self.priority;
            self.customView.customViewFilterDTO.assignee = self.selectedAssignee;
            self.customView.customViewFilterDTO.owner = self.selectedOwner;
            self.customView.customViewFilterDTO.involving = self.selectedInvolving;
            self.customView.customViewFilterDTO.startDateRange = self.startedAfter != "" ? self.startDateRangeRef : [];
            self.customView.customViewFilterDTO.endDateRange = self.finishedAfter != "" ? self.endDateRangeRef : [];
            self.customView.customViewFilterDTO.variableFilterDTOs = self.filterVariables;
            CustomViewAPI.saveCustomView(self.customView, self.isCopyPage ? "new" : self.customViewId).then(response => {
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "aliasName") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    self.customViewName = response.data.processVariables.aliasName;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    let customViewList = [];
                    AdminHttpAPI.getCustomViews().then(customViews => {
                        customViewList = customViews.taskTypeList;
                        EventBus.$emit("updateCustomViewDrilldown", customViewList);
                    });
                    if (self.isEditPage && !self.isCopyPage) {
                        this.initPreviewTable();
                    } else {
                        this.$router
                            .push(
                                this.CONTEXT_PATH + "/processengine/tasks/customview/" + response.data.processVariables.id
                            )
                    }

                }
            }).finally(() => {});
        },
        generatePreviewBtnClick() {
            this.generatePreview();
            this.resetFilter();
        },
        generatePreview() {
            let self = this;
            let validationError = false;
            let procId = self.customView.processVariables.processDefinitionId;
            if (procId == null || procId == "") {
                displayErrorMessage($(self.$refs.processDefinitionId), "Process is required")
                self.$refs.processDefinitionId.classList.add("ms-is-invalid")
                validationError = true;
            }
            let selVars = self.$refs.variables.value;
            if (selVars.length == 0) {
                displayErrorMessage($(self.$refs.variables), "Process variables is required")
                self.$refs.variables.classList.add("ms-is-invalid")
                validationError = true;
            }
            if (validationError) {
                return;
            }
            self.showPreviewGrid = true;
            self.initPreviewTable();
        },
        initPreviewTable() {
            let self = this;
            self.previewCall = false;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            let prop = {
                name: {
                    type: "string",
                    title: "Name",
                    sortable: true,
                    template: '<div class="dateTemplate"><a class="name-link" data-id="{{id}}">{{name}}</a></div>',
                },
                assignee: {
                    type: "string",
                    title: "Assignee",
                    sortable: true,
                },
                owner: {
                    type: "string",
                    title: "Owner",
                    sortable: true,
                },
                prettyStartTime: {
                    type: "string",
                    title: "Created",
                    template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{createdDateString}}</div></div>',
                    sortable: true,
                },
                prettyDueDate: {
                    type: "string",
                    title: "Due",
                    template: '<div class="dateTemplate"><u>{{prettyDueDate}}</u><div>{{dueDateObjectString}}</div></div>',
                    sortable: true,
                },
                prettyClaimTime: {
                    type: "string",
                    title: "Claimed",
                    template: '<div class="dateTemplate"><u>{{prettyClaimTime}}</u><div>{{claimedDateString}}</div></div>',
                    sortable: false,
                },
                prettyEndTime: {
                    type: "string",
                    title: "Completed",
                    sortable: true,
                    template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{completedDateString}}</div></div>',
                },
                prettyDurationInMillis: {
                    type: "string",
                    title: "Duration",
                    sortable: true,
                    template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                },
                priority: {
                    type: "string",
                    title: "Priority",
                    sortable: true,
                },
                prettyWorkTimeInMillis: {
                    type: "string",
                    title: "Work time",
                    sortable: false,
                    template: '<div class="dateTemplate"><u>{{prettyWorkTimeInMillis}}</u><div>{{workTimeInMillis}}</div></div>',
                },
            };

            let selectedVariables = self.customView.customViewFilterDTO.variables;
            $.each(selectedVariables, function (i, value) {
                prop[selectedVariables[i]] = {
                    type: "string",
                    title: selectedVariables[i],
                    sortable: false
                }
            });

            self.tableObj = window.tableFactory.create(document.getElementById("customViewtableTask"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No tasks found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: prop
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (self.tableObj != null) {
                        self.currentPageSize =
                            self.tableObj.tableContext.store.state.pageSize;
                    }

                    if (sortHeader == null) {
                        sortHeader = "prettyStartTime";
                    }
                    if (sortDirection == null) {
                        sortDirection = "desc";
                    }
                    if (sortHeader == "prettyStartTime") {
                        sortHeader = "startTime";
                    } else if (sortHeader == "prettyEndTime") {
                        sortHeader = "endTime";
                    } else if (sortHeader == "prettyDurationInMillis") {
                        sortHeader = "duration";
                    } else if (sortHeader == "prettyDueDate") {
                        sortHeader = "dueDate";
                    }
                    let procDefName = "";
                    if (self.isEditPage) {
                        procDefName = self.customView.processDefinitionName;
                    } else {
                        procDefName = $("#processDefinitionId option:selected")[0].innerText;
                    }
                    let queryString =
                        "start=" +
                        start +
                        "&length=" +
                        self.currentPageSize +
                        "&sort=" +
                        sortHeader +
                        "&dir=" +
                        sortDirection +
                        "&processDefinitionName=" +
                        procDefName +
                        "&filterInput=true";

                    if (self.taskName != "") {
                        queryString += "&taskName=" + self.taskName;
                    }

                    if (self.startedAfter != "") {
                        queryString +=
                            "&taskCreatedAfter=" +
                            self.startedAfter +
                            "&taskCreatedBefore=" +
                            this.startedBefore;
                    }

                    if (self.finishedAfter != "") {
                        queryString +=
                            "&taskCompletedAfter=" +
                            self.finishedAfter +
                            "&taskCompletedBefore=" +
                            self.finishedBefore;
                    }

                    if (self.statusType == "open") {
                        queryString = queryString + "&finished=false";
                    } else if (self.statusType == "completed") {
                        queryString = queryString + "&finished=true";
                    }

                    if (self.selectedInvolving != "") {
                        queryString += "&taskInvolvedUser=" + encodeURI(self.selectedInvolving);
                    }

                    if (self.priority.trim() != "") {
                        queryString += "&taskPriority=" + self.priority;
                    }

                    if (self.selectedOwner != "") {
                        queryString += "&taskOwner=" + encodeURI(self.selectedOwner);
                    }

                    if (self.selectedAssignee != "") {
                        queryString += "&taskAssignee=" + encodeURI(self.selectedAssignee);
                    }

                    return TaskAPI.getAllTasks(queryString, self.filterVariables).then(result => {
                        let responseData = {
                            totalCount: 0,
                            data: []
                        };
                        responseData.totalCount = result.page.totalElements;
                        result.data.forEach(item => {
                            item['createdDateString'] = item['createdDate'] != null ? Utils.getMomentDateString(item['createdDate']) : ''
                            item['dueDateObjectString'] = item['dueDateObject'] != null ? Utils.getMomentDateString(item['dueDateObject']) : ''
                            item['claimedDateString'] = item['claimedDate'] != null ? Utils.getMomentDateString(item['claimedDate']) : ''
                            item['completedDateString'] = item['completedDate'] != null ? Utils.getMomentDateString(item['completedDate']) : ''
                            item['durationInMillis'] = item['durationInMillis'] != null ? item['durationInMillis'] + ' ms' : '';
                            item['workTimeInMillis'] = item['workTimeInMillis'] != null ? item['workTimeInMillis'] + ' ms' : '';
                        });
                        self.updateDynamicParameters(responseData, result);

                        return responseData;
                    });
                },
                onAfterDataLoad: (start, limit) => {
                    self.previewCall = true;
                    self.updateProcessTemplate();
                }
            });
        },
        updateProcessTemplate() {
            let self = this;
            this.$refs.customViewtableTask
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/tasks/" + reference.trim()
                            );
                        }
                    });
                });
        },
        updateDynamicParameters(responseData, result) {
            let self = this;
            if (result.data != null) {
                result.data.forEach(row => {
                    let selectedVars = self.customView.customViewFilterDTO.variables;

                    if (selectedVars != null && selectedVars.length > 0) {
                        for (let i = 0; i < selectedVars.length; i++) {
                            row[selectedVars[i]] = "";
                        }
                    }
                    if (row.queryVariables != null) {
                        row.queryVariables.forEach(function (element) {
                            let currentlet = element.varName;

                            let varValue = "";
                            if (element.value != null) {
                                varValue = element.value;
                            } else if (element.varValue != null) {
                                varValue = element.varValue;
                            }

                            // row[currentVar] = varValue;
                        });
                    }
                });
                responseData.data = result.data;
                self.tableData = responseData.data;
            }
        },
        handleDialogClose(e) {
            let self = this;
            CustomViewAPI.deleteCustomView(self.$route.params.customViewId).then(response => {
                if (response != null && response.error == false) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                    let customViewList = [];
                    AdminHttpAPI.getCustomViews().then(customViews => {
                        customViewList = customViews.taskTypeList;
                        EventBus.$emit("updateCustomViewDrilldown", customViewList);
                    });

                    self.$router.push(
                        self.CONTEXT_PATH + '/processengine/tasks'
                    );
                }
            });
            self.$refs.deleteCustomViewDialog.close()

        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.customView.processVariables.aliasName = event.target.value;
        }
    }
}
</script>

<style scoped>
.mcc-button__dropdown-caret {
    margin-right: 0;
}
.mcc-menu__split-button {
    margin: 0;
}
</style>
